// src/utils/supabasePatch.ts
import { supabase } from '@/lib/supabaseClient';
import { FIELD_MAP } from '@/utils/patchMap';

export function isEmpty(obj: unknown): boolean {
  return !obj || (typeof obj === 'object' && Object.keys(obj as any).length === 0);
}

export async function patchBot(params: { userId: string; botId: string; patch: any; reason?: string; }) {
  const { userId, botId, patch } = params;

  if (isEmpty(patch)) return { ok: true, ignored: true as const };

  const snakePatch: Record<string, any> = {};
  for (const [k, v] of Object.entries(patch)) {
      if (v === undefined) continue;
      const snake = FIELD_MAP[k] || k.replace(/[A-Z]/g, m => '_' + m.toLowerCase());
      
      if (typeof v === 'string' && v.trim() === '') {
          snakePatch[snake] = null;
      } else {
          snakePatch[snake] = v;
      }

      if (snake === 'long_entry_enabled' || k === 'longEnabled') {
          const isTrue = (v === true || v === 'true' || v === 1 || v === '1');
          snakePatch['long_entry_enabled'] = isTrue;
          snakePatch['long_enabled'] = isTrue;
          snakePatch['buy_enabled'] = isTrue;
      }
      if (snake === 'short_entry_enabled' || k === 'shortEnabled') {
          const isTrue = (v === true || v === 'true' || v === 1 || v === '1');
          snakePatch['short_entry_enabled'] = isTrue;
          snakePatch['short_enabled'] = isTrue;
          snakePatch['sell_enabled'] = isTrue;
      }
      
      if (snake === 'buy_order_type') snakePatch['long_order_type'] = snakePatch[snake];
      if (snake === 'sell_order_type') snakePatch['short_order_type'] = snakePatch[snake];
      if (snake === 'max_open_orders') snakePatch['max_open_sell_orders'] = snakePatch[snake];
  }

  delete snakePatch['config_snapshot'];
  delete snakePatch['settings'];
  delete snakePatch['settings_json'];
  delete snakePatch['id'];

  if (isEmpty(snakePatch)) return { ok: true, ignored: true as const };

  console.log('[PATCH BOT] Tiesioginis DB Update (Be RPC!):', snakePatch);

  const { data, error } = await supabase
    .from('bots')
    .update(snakePatch)
    .eq('id', botId)
    .eq('user_id', userId)
    .select()
    .single();

  if (error) {
    console.error('[PATCH BOT ERROR]', error.message);
    throw error;
  }
  
  return { ok: true, data, error: null };
}